import { render, staticRenderFns } from "./MaskProperties.vue?vue&type=template&id=ee3cde6c&scoped=true"
import script from "./MaskProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaskProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MaskProperties.vue?vue&type=style&index=0&id=ee3cde6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3cde6c",
  null
  
)

export default component.exports